import { createSelector } from 'reselect';

import { DEFAULT_CREATE_SEND_CONTENTS_ATTEMPT_STATE } from '../../../constants/createSendContentsAttempt';
import { ICreateSendUnsetMskuState } from '../../../types/createSendContents';
import { IAppState } from '../../reducers';
import {
  selectCsFirstUnsetMsku,
  selectCsUnsetMskuCount,
  selectCsUnsetMskuKey,
  selectIsCsLocationSendEmpty,
} from './locationUnset';

export const selectCsContentsAttemptState = (state: IAppState) =>
  state.createSend.contentsAttempt ?? DEFAULT_CREATE_SEND_CONTENTS_ATTEMPT_STATE;

export const selectCsAttemptedUnsetKey = createSelector(
  selectCsContentsAttemptState,
  (attempt) => attempt.attemptedUnsetKey,
);

export const selectCsUnsetHighlightGeneration = createSelector(
  selectCsContentsAttemptState,
  (attempt) => attempt.highlightGeneration,
);

export const selectIsCsContinueAttempted = createSelector(
  selectCsAttemptedUnsetKey,
  selectCsUnsetMskuKey,
  (attemptedKey, currentKey): boolean => currentKey !== null && attemptedKey === currentKey,
);

export const selectCsUnsetMskuState = createSelector(
  selectCsUnsetMskuCount,
  selectCsFirstUnsetMsku,
  selectIsCsLocationSendEmpty,
  selectIsCsContinueAttempted,
  selectCsUnsetMskuKey,
  (count, first, isSendEmpty, attempted, key): ICreateSendUnsetMskuState => ({
    count,
    firstName: first?.name ?? '',
    isSendEmpty,
    attempted,
    key,
  }),
);
